<div class="cookie-banner" *ngIf="visibleBanner" [ngClass]="bannerAnimationClass">
  <div class="content">
    <div class="banner-copy">
      <h3>{{ "COOKIE_BANNER.BANNER_TITLE" | translate }}</h3>
      <p>{{ "COOKIE_BANNER.BANNER_DESCRIPTION" | translate }}</p>
      <p>{{ "COOKIE_BANNER.BANNER_PREFERENCES" | translate }}</p>
      <p [innerHTML]="'COOKIE_BANNER.BANNER_POLICY' | translate"></p>
    </div>
    <div class="actions">
      <ion-button
        fill="solid"
        size="small"
        color="primary"
        (click)="acceptAll()"
        >{{ "COOKIE_BANNER.ACCEPT_ALL" | translate }}</ion-button
      >
      <ion-button
        fill="outline"
        size="small"
        color="danger"
        (click)="rejectAll()"
        >{{ "COOKIE_BANNER.REJECT" | translate }}</ion-button
      >
      <ion-button fill="outline" size="small" (click)="openConfig()">{{
        "COOKIE_BANNER.CONFIGURE" | translate
      }}</ion-button>
    </div>
  </div>
</div>

<div class="cookie-config-overlay" *ngIf="visibleConfig" [ngClass]="[overlayAnimationClass, overlayVisibleClass]">
  <div class="cookie-config-modal" [ngClass]="modalAnimationClass">
    <div class="modal-header">
      <div class="modal-title">
        <ion-icon name="settings-outline"></ion-icon>
        <h2>{{ "COOKIE_BANNER.CONFIG_TITLE" | translate }}</h2>
      </div>
      <ion-button fill="clear" (click)="closeConfig()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </div>

    <div class="modal-content">
      <div class="section">
        <div class="section-header">
          <h3>{{ "COOKIE_BANNER.TECHNICAL.TITLE" | translate }}</h3>
          <ion-toggle [checked]="true" [disabled]="true"></ion-toggle>
        </div>
        <p>
          {{ "COOKIE_BANNER.TECHNICAL.DESCRIPTION" | translate }}
        </p>
        <p>
          <strong>{{ "COOKIE_BANNER.TECHNICAL.INCLUDE_LABEL" | translate }}</strong>
        </p>
        <div class="cookie-subsection">
          <p class="subsection-title">{{ "COOKIE_BANNER.TECHNICAL.OWN_TITLE" | translate }}</p>
          <ul>
            <li *ngFor="let item of technicalOwnList">● {{ item }}</li>
          </ul>
        </div>
        <div class="cookie-subsection">
          <p class="subsection-title">{{ "COOKIE_BANNER.TECHNICAL.STRIPE_TITLE" | translate }}</p>
          <ul>
            <li *ngFor="let item of technicalStripeList">● {{ item }}</li>
          </ul>
        </div>
        <p>
          <strong>{{ "COOKIE_BANNER.TECHNICAL.EXAMPLES_TITLE" | translate }}</strong>
        </p>
        <ul>
          <li *ngFor="let item of technicalExampleList">● {{ item }}</li>
        </ul>
        <p class="status-pill">
          <ion-icon name="lock-closed-outline"></ion-icon>
          <span>{{ "COOKIE_BANNER.TECHNICAL.ALWAYS_ACTIVE" | translate }}</span>
        </p>
      </div>

      <div class="section">
        <div class="section-header">
          <h3>{{ "COOKIE_BANNER.THIRD_PARTY.TITLE" | translate }}</h3>
        </div>
        <p>{{ "COOKIE_BANNER.THIRD_PARTY.DESCRIPTION" | translate }}</p>

        <div class="providers">
          <div class="provider-row" *ngFor="let provider of thirdPartyProviders">
            <div>
              <strong>{{ provider.labelKey | translate }}</strong>
            </div>
            <div class="provider-toggle">
              <span>{{ "COOKIE_BANNER.THIRD_PARTY.ENABLE_LABEL" | translate }}</span>
              <ion-toggle [(ngModel)]="consent.providers[provider.id]"></ion-toggle>
            </div>
          </div>
        </div>
        <p class="section-note">{{ "COOKIE_BANNER.THIRD_PARTY.DEFAULT_DISABLED" | translate }}</p>
      </div>
    </div>

    <div class="modal-footer">
      <div class="footer-title">{{ "COOKIE_BANNER.ACTIONS.TITLE" | translate }}</div>
      <div class="footer-actions">
        <ion-button
          expand="block"
          fill="outline"
          color="primary"
          (click)="saveConfig()"
          >{{ "COOKIE_BANNER.ACTIONS.SAVE_CONFIG" | translate }}</ion-button
        >
        <ion-button
          fill="solid"
          size="small"
          color="primary"
          (click)="acceptAll()"
          >{{ "COOKIE_BANNER.ACTIONS.ACCEPT_ALL" | translate }}</ion-button
        >
        <ion-button
          expand="block"
          fill="outline"
          color="danger"
          (click)="rejectAll()"
          >{{ "COOKIE_BANNER.ACTIONS.REJECT_ALL" | translate }}</ion-button
        >
      </div>
    </div>
  </div>
</div>

<button
  *ngIf="shouldShowFooterLink()"
  type="button"
  class="cookie-footer-link"
  [attr.aria-label]="'COOKIE_BANNER.CONFIGURE' | translate"
  (click)="openConfig()"
>
  <ion-icon name="settings-outline"></ion-icon>
  <span class="cookie-footer-link__label">{{ 'COOKIE_BANNER.CONFIGURE' | translate }}</span>
</button>
